/* import __COLOCATED_TEMPLATE__ from './no-conversations-found-empty-state.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();